import {
  Destination,
  ExistingDestination,
  getDefaultDestination,
  prepareDestinationFromExisting,
} from "@prequel/react";

// Changing only these cannot break connectivity, so they can be saved without a fresh connection test.
const SAFE_FIELDS = ["frequency_minutes", "enabled_models", "name", "products"];

// The form state a destination loads with. useDestination seeds itself from getDefaultDestination and
// its setter merges rather than replaces, so the loaded form holds every default key too.
export const initialFormState = (destination: ExistingDestination): Destination => ({
  ...getDefaultDestination(),
  ...prepareDestinationFromExisting(destination),
});

// True when the form only has pending edits in the SAFE_FIELDS. Both arguments are form state.
export const canSaveWithoutTest = (initial: Destination, current: Destination): boolean => {
  const changedKeys = (Object.keys({ ...initial, ...current }) as Array<keyof Destination>).filter(
    (key) => initial[key] !== current[key],
  );

  return changedKeys.length > 0 && changedKeys.every((key) => SAFE_FIELDS.includes(key));
};
